import * as constants from './upgrade-constants';
import R from 'ramda';

const openUpgrade = () => (
  {
    type: constants.OPEN,
  }
);

export const closeUpgrade = () => (
  {
    type: constants.CLOSE,
  }
);

const resetUpgrade = () => (
  {
    type: constants.RESET,
  }
);

const syncUpgrade = () => (
  {
    type: constants.SYNC,
  }
);

export const openUpgradeFrom = (from, obj) => (dispatch, getState) => {
  const partnerFinder = getState().partnerFinder.toJS();
  const { type, nameForIntercom, eventAction, eventValue, payload } = (() => {
    if (from === 'profileViews') {
      return {
        type: constants.WHO_VIEW_MY_PROFILE,
        nameForIntercom: '[Profile]Who viewed my profile',
        eventAction: 'Click from profile views',
        payload: {},
      };
    }
    if (from === 'pfListConnectBtn') {
      return {
        type: constants.PARTNER_FINDER_CONNECT,
        nameForIntercom: '[Partner Finder] Upgrade Button Click',
        eventAction: 'Click from PF',
        payload: {
          clickedCompany: obj.clickedCompany,
          searchCountry: R.path(['searchParams', 'destinationsSold', 0], partnerFinder),
          searchResults: partnerFinder.total || 0,
        },
      };
    }
    if (from === 'profileConnectBtn') {
      return {
        nameForIntercom: '[Profile] Upgrade to Connect',
        eventAction: 'Click from profile connect Btn',
        payload: {},
      };
    }
    if (from === 'contractListSentFilters') {
      return {
        type: constants.CONTRACT_LIST_SENT_TRACKING,
        nameForIntercom: '[Contract List] Upgrade to Filter Sent Filters',
        eventAction: 'Click from contract list sent filters',
        payload: {},
      };
    }
    if (from === 'contractListSentStatus') {
      return {
        type: constants.CONTRACT_LIST_SENT_TRACKING,
        nameForIntercom: '[Contract List] Upgrade to See Email Tracking',
        eventAction: 'Click from contract list sent icon',
        payload: {},
      };
    }
    if (from === 'contractListBounced') {
      return {
        type: constants.CONTRACTING_BOUNCED,
        nameForIntercom: '[Contract List] Upgrade to See who bounced',
        eventAction: 'Click from contract list Outbox',
        payload: {},
      };
    }
    if (from === 'downloadContractingReportBtn') {
      return {
        type: constants.CONTRACTING_REPORTS,
        nameForIntercom: '[Contract Reports] Upgrade to download contracting reports',
        eventAction: 'Click from contracting report download',
        payload: {},
      };
    }
    if (from === 'contractListBulkActions') {
      return {
        type: constants.CONTRACT_LIST_BULK_ACTIONS,
        nameForIntercom: '[Contract Reports] Upgrade to bulk action',
        eventAction: 'Click from contract list bulk action',
        eventValue: obj.bulkAction,
        payload: {
          bulkAction: obj.bulkAction, // accept, reject, download, load, folders, trash
        },
      };
    }
    if (from === 'ratesOnlyPDF') {
      return {
        type: '',
        nameForIntercom: '[Contract PDF Download] Upgrade to download rates-only version',
        eventAction: 'Click from rates-only PDF download',
      };
    }
    if (from === 'massMessaging') {
      return {
        type: '',
        nameForIntercom: '[Mass Messaging] Upgrade to add more destinations',
        eventAction: 'Click from adding more destinations',
      };
    }
    return {};
  })();

  dispatch({
    type: 'TRACK_EVENT',
    payload: {
      name: nameForIntercom,
      ga: {
        hitType: 'event',
        eventCategory: 'upgrade point click',
        eventAction,
        eventValue,
        eventLabel: `${getState().user.toJS().company.companyName} - ${getState().user.toJS().user.name}`,
      },
    },
  });

  return dispatch({ type: constants.REASON, payload: Object.assign({}, payload, { upgradeReason: type }) })
  .then(dispatch(openUpgrade()));
};


export const upgradeResetAndClose = () => dispatch => {
  dispatch(resetUpgrade());
  dispatch(closeUpgrade());
};



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/upgrade/upgrade-actions.js